import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { CourseTypes, Institution } from '@/models/catalog/course';

export const useInstitutionsLogo = (courseType: CourseTypes) => {
  const response = useQuery<{ data: { institutions: Institution[] } }>({
    queryKey: [clientKeys.useInstitutionsLogo, courseType],
    queryFn: async () =>
      await edupassClient.get(`/course_types/${courseType}/institutions`),
  });

  return { institutions: response?.data?.data?.institutions, ...response };
};
